export var NotificationType;
(function (NotificationType) {
    NotificationType["NotificationTypeUnknown"] = "NOTIFICATION_TYPE_UNKNOWN";
    NotificationType["BackupJobFailed"] = "BACKUP_JOB_FAILED";
    NotificationType["BackupJobSucceeded"] = "BACKUP_JOB_SUCCEEDED";
    NotificationType["SnapshotIncludesAccessDeniedItems"] = "SNAPSHOT_INCLUDES_ACCESS_DENIED_ITEMS";
    NotificationType["RestoreJobSucceeded"] = "RESTORE_JOB_SUCCEEDED";
    NotificationType["RestoreJobFailed"] = "RESTORE_JOB_FAILED";
    NotificationType["BackupPolicyApplied"] = "BACKUP_POLICY_APPLIED";
    NotificationType["BackupPolicyUnapplied"] = "BACKUP_POLICY_UNAPPLIED";
    NotificationType["BackupPolicyCreated"] = "BACKUP_POLICY_CREATED";
    NotificationType["BackupPolicyUpdated"] = "BACKUP_POLICY_UPDATED";
    NotificationType["BackupPolicyDeleted"] = "BACKUP_POLICY_DELETED";
    NotificationType["BackupVaultCreated"] = "BACKUP_VAULT_CREATED";
    NotificationType["BackupVaultDeleted"] = "BACKUP_VAULT_DELETED";
    NotificationType["CloudAccountCreated"] = "CLOUD_ACCOUNT_CREATED";
    NotificationType["CloudAccountUpdated"] = "CLOUD_ACCOUNT_UPDATED";
    NotificationType["CloudAccountDeleted"] = "CLOUD_ACCOUNT_DELETED";
    NotificationType["CloudAccountDeactivated"] = "CLOUD_ACCOUNT_DEACTIVATED";
    NotificationType["CloudAccountActivated"] = "CLOUD_ACCOUNT_ACTIVATED";
    NotificationType["RansomwareDetectedInResource"] = "RANSOMWARE_DETECTED_IN_RESOURCE";
    NotificationType["RansomwareDetectedInSnapshot"] = "RANSOMWARE_DETECTED_IN_SNAPSHOT";
    NotificationType["RansomwareInfectionRemediated"] = "RANSOMWARE_INFECTION_REMEDIATED";
    NotificationType["ResourceExcludedFromRansomwareDetection"] = "RESOURCE_EXCLUDED_FROM_RANSOMWARE_DETECTION";
    NotificationType["RansomwareDetectionExclusionCanceled"] = "RANSOMWARE_DETECTION_EXCLUSION_CANCELED";
    NotificationType["ViolationsDetectedOnResources"] = "VIOLATIONS_DETECTED_ON_RESOURCES";
    NotificationType["ViolationsResolvedOnResources"] = "VIOLATIONS_RESOLVED_ON_RESOURCES";
    NotificationType["IssueMutedOnResource"] = "ISSUE_MUTED_ON_RESOURCE";
    NotificationType["IssueUnmutedOnResource"] = "ISSUE_UNMUTED_ON_RESOURCE";
    NotificationType["AuditLogCreated"] = "AUDIT_LOG_CREATED";
    NotificationType["JobMetricsReportFailed"] = "JOB_METRICS_REPORT_FAILED";
    NotificationType["SnapshotUserProtected"] = "SNAPSHOT_USER_PROTECTED";
    NotificationType["SnapshotUserUnprotected"] = "SNAPSHOT_USER_UNPROTECTED";
    NotificationType["ClassificationJobFailed"] = "CLASSIFICATION_JOB_FAILED";
    NotificationType["CreditsUsageThreshold75"] = "CREDITS_USAGE_THRESHOLD_75";
    NotificationType["CreditsUsageThreshold90"] = "CREDITS_USAGE_THRESHOLD_90";
    NotificationType["CreditsUsageThreshold95"] = "CREDITS_USAGE_THRESHOLD_95";
    NotificationType["CreditsMonthlyUsage80"] = "CREDITS_MONTHLY_USAGE_80";
    NotificationType["CreditsMonthlyUsage90"] = "CREDITS_MONTHLY_USAGE_90";
    NotificationType["CreditsMonthlyUsage100"] = "CREDITS_MONTHLY_USAGE_100";
    NotificationType["MalwareDetectedInSnapshot"] = "MALWARE_DETECTED_IN_SNAPSHOT";
    NotificationType["DataAnomalyDetectedInSnapshot"] = "DATA_ANOMALY_DETECTED_IN_SNAPSHOT";
    NotificationType["MalwareRemediated"] = "MALWARE_REMEDIATED";
    NotificationType["DataAnomalyRemediated"] = "DATA_ANOMALY_REMEDIATED";
    NotificationType["MpaRequestPendingApproval"] = "MPA_REQUEST_PENDING_APPROVAL";
    NotificationType["MpaRequestApproved"] = "MPA_REQUEST_APPROVED";
    NotificationType["MpaRequestDenied"] = "MPA_REQUEST_DENIED";
    NotificationType["MpaRequestPartiallyApproved"] = "MPA_REQUEST_PARTIALLY_APPROVED";
    NotificationType["MpaRequestExecuted"] = "MPA_REQUEST_EXECUTED";
    NotificationType["MpaRequestExpired"] = "MPA_REQUEST_EXPIRED";
    NotificationType["MpaRequestCancelled"] = "MPA_REQUEST_CANCELLED";
    NotificationType["GdsgSlaBreached"] = "GDSG_SLA_BREACHED";
    NotificationType["GdsgSystemInaccessible"] = "GDSG_SYSTEM_INACCESSIBLE";
    NotificationType["GdsgWorkerFailure"] = "GDSG_WORKER_FAILURE";
})(NotificationType || (NotificationType = {}));
